export default function (instance) {
    return {
        createOrUpdateGroup(caseId, data) {
            return instance.post(`/inscope/case/${caseId}`, data);
        },
        getInScopeGroupAndContacts(caseId, page, size, keySearch, order) {
            return instance.get(`/inscope/case/${caseId}?page=${page}&size=${size}&keySearch=${keySearch}&order=${order}`);
        },
        editInScopeGroup(groupId, data) {
            return instance.put(`/inscope/group/${groupId}`, data);
        },
        deleteInScopeGroup(data) {
            return instance.post('/inscope/group/delete', data);
        },
        createInScopeContact(caseId, groupId, data) {
            return instance.post(`/inscope/case/${caseId}/group/${groupId}/contact`, data);
        },
        editInScopeContact(groupId, contactId, data) {
            return instance.put(`/inscope/group/${groupId}/contact/${contactId}`, data);
        },
        deleteInScopeContact(caseId, groupId, contactId) {
            return instance.delete(`/inscope/case/${caseId}/group/${groupId}/contact/${contactId}`);
        },
    };
}
